export enum ExamType {
    REMOTE = "RE",
    PRELIMINARY = "PE",
    TESTING_CENTER = "CE",
    EXPERIENCE = "XE",
}

export namespace ExamType {
    export function toString(examType: ExamType): string {
        switch (examType) {
            case ExamType.REMOTE:
                return "remote";
            case ExamType.PRELIMINARY:
                return "preliminary";
            case ExamType.EXPERIENCE:
                return "experience";
            case ExamType.TESTING_CENTER:
                return "testing center";

        }
        return "unknown";
    }
}


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/enums/exam-type.enum.ts